import { omit } from "lodash";

import { ICreateContactFormPayload, IUpdateContactFormPayload } from "store/entities/contact-forms/interfaces";

import { IRequestResult } from "../api-client";
import { BaseApi } from "../base";

import { IFormModifyPayload, IRawContactForm } from "./interfaces";

export function parsePayload(payload: ICreateContactFormPayload | IUpdateContactFormPayload): IFormModifyPayload {
  const {
    name,
    teamID,
    livechatGroupIDs: lcGroupIDs,
    version,
    ...settings
  } = omit(payload, ["id", "licenseID", "wordpressContactForm"]);

  return { name, teamID, lcGroupIDs, settings, version };
}

export default class ContactFormsApi extends BaseApi {
  protected readonly prefix = "contactForms";

  fetch = (id: string): Promise<IRequestResult<IRawContactForm>> => this.get(id);
  fetchAll = (): Promise<IRequestResult<IRawContactForm[]>> => this.get("");

  create = (payload: ICreateContactFormPayload): Promise<IRequestResult<IRawContactForm>> =>
    this.post("", parsePayload(payload));

  update = (id: string, payload: IUpdateContactFormPayload): Promise<IRequestResult<IRawContactForm>> =>
    this.patch(id, parsePayload(payload));

  destroy = (id: string): Promise<IRequestResult<"OK">> => this.delete(id);
}
